module.exports = __webpack_public_path__ + "src/assets/images/icon-tab-chat.png?9198a4358929975a5d89e3f65c4ac8dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tab-chat.png
// module id = 1008
// module chunks = 1